import { Divider, Stack } from "@mui/material";
import { useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import TextInput from "components/files/TextInput";
import CustomButton from "components/CustomButton";
import { useEffect } from "react";

const { default: CustomDialog } = require("components/CustomDialog")

const CloseService = ({ data, setData, onFinishService }) => {
    const { handleSubmit, reset, control, formState: { errors } } = useForm();
    const employees = useSelector((state) => state?.employees?.list);

    useEffect(() => {
        reset(data?.call)
    }, [data?.open]);

    const onClose = () => {
        setData({ open: false, call: null })
    }

    const onSubmit = (values) => {
        onFinishService({
            call: data?.call,
            notes: values?.notes,
            jobDoneDesc: values?.jobDoneDesc,
        })
        onClose()
    }

    if (employees.length === 0) return

    return (
        <CustomDialog width={350} open={data?.open} onClose={onClose} title='CLOSE_SERVICE'>
            <form
                style={{
                    display: "flex",
                    flexDirection: 'column',
                    justifyContent: 'space-between',
                }}
                onSubmit={handleSubmit(onSubmit)}
            >
                <Stack spacing={2}>
                    <TextInput
                        width="100%"
                        errors={errors}
                        name="notes"
                        title="NOTES"
                        rows={2}
                        control={control}
                    />

                    <Divider />

                    <Stack direction='row' spacing={2}>
                        <CustomButton fullWidth variant='outlined' title='CANCEL' onClick={onClose} />
                        <CustomButton fullWidth title='ACCEPT' submit />
                    </Stack>
                </Stack>

            </form>
        </CustomDialog>
    )
}

export default CloseService